import React from 'react';
import { observer } from 'mobx-react';
import { TafCookieNotification } from '@taf-ui/react';

import './CookieNotification.css';
import { translate } from '../utils/utils';
import Labels from '../enums/Labels';
import AppStorage from '../Storage/Storage';

interface CookieNotificationProps {
  clickHandler(data: boolean): void;
}

class CookieNotification extends React.PureComponent<CookieNotificationProps> {
  private readonly storage: AppStorage;

  constructor(props: CookieNotificationProps) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  render(): React.ReactElement {
    const {
      clickHandler,
    } = this.props;

    return (
      <div className="cookie-component-wrapper">
        <TafCookieNotification
          message={translate(Labels.COOKIE_NOTIFICATION_MESSAGE, this.storage.getLocale)}
          allowButtonCaption={translate(Labels.COOKIE_NOTIFICATION_ALLOW, this.storage.getLocale)}
          denyButtonCaption={translate(Labels.COOKIE_NOTIFICATION_DENY, this.storage.getLocale)}
          onTafClick={(data) => clickHandler(data.detail.accepted)}
        ></TafCookieNotification>
      </div>
    );
  }
}

export default observer(CookieNotification);
